import React from "react";
import "./ApplicationCard.scss";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAppStore, faGooglePlay} from "@fortawesome/free-brands-svg-icons";

function ApplicationCard({application}) {
    const playStore = application.stores?.find(store => store.storeType === "play_store");
    const appStore = application.stores?.find(store => store.storeType === "app_store");

    const navigate = useNavigate();

    const handleEdit = () => {
        navigate(`${application.id}`);
    }

    return (
        <div className="card" onClick={handleEdit}>
            <div className="card-content">
                <img
                    src={application.icon || "https://via.placeholder.com/150"}
                    alt="App Icon"
                    className="app-icon"
                />
                <div className="details">
                    <h2>{application.name}</h2>
                    {!!application.category && <p className="category">{application.category}</p>}
                    {!!application.rating && <div className="rating"><span>{application.rating} ★</span></div>}
                </div>
                <div className="store-icons">
                    {!!playStore && (
                        <a href={`https://play.google.com/store/apps/details?id=${playStore.storeId}`} target="_blank" rel="noreferrer">
                            <FontAwesomeIcon className="store-icon" icon={faGooglePlay} size="xl"/>
                        </a>
                    )}
                    {!!appStore && (
                        <a href={appStore.link} target="_blank" rel="noreferrer">
                            <FontAwesomeIcon className="store-icon" icon={faAppStore} size="xl"/>
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

export {ApplicationCard};
